import { Component } from './Component';
import { ComponentDecisions } from './types';
import {
    AccordionVariant,
    AlertIconVariant,
    BadgeVariant,
    BannerVariant,
    BaseLayoutVariants,
    CalendarFooterVariant,
    CalendarSelectorVariant,
    CardContentVariant,
    IconVariant,
    LayoutCellVariants,
    LegendCircleVariant,
    MessageAuthor,
    MewsLogoVariant,
    NestedCardVariant,
    SystemWideBannerVariant,
    TypographyVariant,
} from './variants';

export interface Decisions {
    [Component.Accordion]: ComponentDecisions<AccordionVariant>;
    [Component.Alert]: ComponentDecisions;
    [Component.AlertIcon]: ComponentDecisions<AlertIconVariant>;
    [Component.Backdrop]: ComponentDecisions;
    [Component.Banner]: ComponentDecisions<BannerVariant>;
    [Component.BannerPrimaryText]: ComponentDecisions;
    [Component.BannerSecondaryText]: ComponentDecisions;
    [Component.BareIconButton]: ComponentDecisions;
    [Component.Calendar]: ComponentDecisions;
    [Component.CalendarFooter]: ComponentDecisions<CalendarFooterVariant>;
    [Component.CalendarSelector]: ComponentDecisions<CalendarSelectorVariant>;
    [Component.Card]: ComponentDecisions;
    [Component.CardContent]: ComponentDecisions<CardContentVariant>;
    [Component.Dialog]: ComponentDecisions;
    [Component.Drawer]: ComponentDecisions;
    [Component.DrawerPill]: ComponentDecisions;
    [Component.Flag]: ComponentDecisions;
    [Component.Icon]: ComponentDecisions<IconVariant>;
    [Component.LegendCircle]: ComponentDecisions<LegendCircleVariant>;
    [Component.MessageBubble]: ComponentDecisions<MessageAuthor>;
    [Component.MessageTextarea]: ComponentDecisions;
    [Component.MewsLogo]: ComponentDecisions<MewsLogoVariant>;
    [Component.NavigationList]: ComponentDecisions;
    [Component.NestedCard]: ComponentDecisions<NestedCardVariant>;
    [Component.Badge]: ComponentDecisions<BadgeVariant>;
    [Component.SupplementaryIcon]: ComponentDecisions<IconVariant>;
    [Component.SystemWideBanner]: ComponentDecisions<SystemWideBannerVariant>;
    [Component.Textarea]: ComponentDecisions;
    [Component.Typography]: ComponentDecisions<TypographyVariant>;

    /** @deprecated */
    [Component.BaseLayout]: ComponentDecisions<BaseLayoutVariants>;
    /** @deprecated */
    [Component.TwoColumnLayoutCell]: ComponentDecisions<LayoutCellVariants>;
    /** @deprecated */
    [Component.ThreeColumnLayoutCell]: ComponentDecisions<LayoutCellVariants>;
    /** @deprecated */
    [Component.FourColumnLayoutCell]: ComponentDecisions<LayoutCellVariants>;
    /** @deprecated */
    [Component.FiveColumnLayoutCell]: ComponentDecisions<LayoutCellVariants>;
    /** @deprecated */
    [Component.ContentWithSidebarLayoutSidebarCell]: ComponentDecisions<LayoutCellVariants>;
    /** @deprecated */
    [Component.ContentWithSidebarLayoutContentCell]: ComponentDecisions<LayoutCellVariants>;
    /** @deprecated */
    [Component.ContentWithTwoSidebarsLayoutSidebarCell]: ComponentDecisions<LayoutCellVariants>;
    /** @deprecated */
    [Component.ContentWithTwoSidebarsLayoutContentCell]: ComponentDecisions<LayoutCellVariants>;
}
